import _ from 'lodash';
import { Moment } from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoints from '../../../../../../common/hooks/useBreakpoints';
import Dialog from '../../../../../../common/widgets/Dialog';
import { TimesheetPresenceTypeCategories } from '../../../../enums';
import { ErrorState } from '../../../../models/Errors';
import {
  File,
  PresenceTypes,
  Timesheet,
} from '../../../../models/TimeAndAttendance';
import { resources } from '../../../../resources/resources';
import { TimeAndAttendanceConfirmForm } from './Forms/TimeAndAttendanceConfirmForm';
import { TimeAndAttendanceForm } from './Forms/TimeAndAttendanceForm';
import { VacationForm } from './Forms/VacationForm';
import { TimeAndAttendanceStep } from './enum';

interface ITimeAndAttendanceDialogProps {
  currentDate: Moment;
  selectedAttendance: Timesheet | undefined;
  setSelectedAttendance: React.Dispatch<
    React.SetStateAction<Timesheet | undefined>
  >;
  setShowAttendanceDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setTimesheet: React.Dispatch<React.SetStateAction<Timesheet[] | undefined>>;
  setFiles: React.Dispatch<React.SetStateAction<File[] | undefined>>;
  availableTimesheetPresenceTypes: PresenceTypes[];
}

export enum TimeAndAttendanceTabs {
  TimeAndAttendance,
  Vacation,
}

export const TimeAndAttendanceDialog = (
  props: ITimeAndAttendanceDialogProps,
) => {
  const [activeTab, setActiveTab] = useState<TimeAndAttendanceTabs>(
    props.selectedAttendance?.presenceType?.categoryId ==
      TimesheetPresenceTypeCategories.Work || !props.selectedAttendance?.id
      ? TimeAndAttendanceTabs.TimeAndAttendance
      : TimeAndAttendanceTabs.Vacation,
  );
  const [activeStep, setActiveStep] = useState<TimeAndAttendanceStep>(
    TimeAndAttendanceStep.Form,
  );
  const [errors, setErrors] = useState<ErrorState>({} as ErrorState);

  const { t: translate } = useTranslation();
  const { isMobile } = useBreakpoints();

  if (
    props.selectedAttendance?.presenceType?.categoryId ==
    TimesheetPresenceTypeCategories.Other
  ) {
    props.setSelectedAttendance({
      ...props.selectedAttendance,
      presenceType: undefined,
    });
  }

  if (
    (props.selectedAttendance?.presenceType?.categoryId ==
      TimesheetPresenceTypeCategories.Work &&
      activeTab != TimeAndAttendanceTabs.TimeAndAttendance) ||
    (props.selectedAttendance?.presenceType?.categoryId ==
      TimesheetPresenceTypeCategories.Vacation &&
      activeTab != TimeAndAttendanceTabs.Vacation)
  ) {
    props.setSelectedAttendance({
      ...props.selectedAttendance,
      presenceType: undefined,
    });
  }

  const dialogFormContent =
    activeTab === TimeAndAttendanceTabs.TimeAndAttendance ? (
      <TimeAndAttendanceForm
        currentDate={props.currentDate}
        setActiveStep={setActiveStep}
        setShowAttendanceDialog={props.setShowAttendanceDialog}
        setTimesheet={props.setTimesheet}
        errors={errors}
        setErrors={setErrors}
        selectedEvent={props.selectedAttendance}
        setSelectedEvent={props.setSelectedAttendance}
        availableTimesheetPresenceTypes={_.filter(
          props.availableTimesheetPresenceTypes,
          function (o) {
            return o.categoryId == TimesheetPresenceTypeCategories.Work;
          },
        )}
      />
    ) : (
      <VacationForm
        currentDate={props.currentDate}
        setActiveStep={setActiveStep}
        setShowAttendanceDialog={props.setShowAttendanceDialog}
        setTimesheet={props.setTimesheet}
        errors={errors}
        setErrors={setErrors}
        selectedEvent={props.selectedAttendance}
        setSelectedEvent={props.setSelectedAttendance}
        availableTimesheetPresenceTypes={_.filter(
          props.availableTimesheetPresenceTypes,
          function (o) {
            return o.categoryId == TimesheetPresenceTypeCategories.Vacation;
          },
        )}
      />
    );

  return (
    <Dialog
      className={`dialog-m taa-dialog ${isMobile && 'mobile-dialog'}`}
      showCloseIcon={true}
      closeOnClickOutside={false}
      closeDialog={() => {
        props.setSelectedAttendance(undefined);
        props.setShowAttendanceDialog(false);
      }}
      {...(activeStep === TimeAndAttendanceStep.Form && {
        headerContent: !props.selectedAttendance?.id ? (
          <ul className="acc-tabs">
            <li
              className={
                activeTab === TimeAndAttendanceTabs.TimeAndAttendance
                  ? 'acc-tab-active'
                  : undefined
              }
              onClick={() =>
                setActiveTab(TimeAndAttendanceTabs.TimeAndAttendance)
              }
            >
              {translate(resources.menu.timeAndAttendance)}
            </li>
            <li
              className={
                activeTab === TimeAndAttendanceTabs.Vacation
                  ? 'acc-tab-active'
                  : undefined
              }
              onClick={() => setActiveTab(TimeAndAttendanceTabs.Vacation)}
            >
              {translate(resources.timeAndAttendance.vacationTab)}
            </li>
          </ul>
        ) : null,
      })}
    >
      {activeStep === TimeAndAttendanceStep.Form ? (
        dialogFormContent
      ) : (
        <TimeAndAttendanceConfirmForm
          setFiles={props.setFiles}
          currentDate={props.currentDate}
          setShowAttendanceDialog={props.setShowAttendanceDialog}
          setTimesheet={props.setTimesheet}
          setActiveStep={setActiveStep}
          event={props.selectedAttendance}
          setErrors={setErrors}
        />
      )}
    </Dialog>
  );
};
